import SmallTable from './SmallTable';

export default SmallTable;
